import { render, staticRenderFns } from "./AnchorLocationCard.vue?vue&type=template&id=7136e404"
import script from "./AnchorLocationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnchorLocationCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports